export default "__VITE_ASSET__7b4e050b__"